import type {FC} from 'react';

import Calendar from '@yourcoach/shared/assets/icons/calendar.svg';

interface Props {
  className?: string;
  height?: string;
  viewBox?: string;
  width?: string;
}

const IconCalendar: FC<Props> = ({
  className = 'icon',
  height = '100%',
  viewBox = '0 0 24 24',
  width = '100%',
}) => {
  return (
    <div className={`IconCalendar fill ${className}`}>
      <Calendar
        fill="#819AA9"
        height={height}
        viewBox={viewBox}
        width={width}
      />
    </div>
  );
};

export default IconCalendar;
